/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { Flex, Heading, Button } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { siteSLADefault } from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";

export default function SiteSLAs({ onNextStep, onPrevStep, SLAs, addData }) {
  const [currentEditing, setCurrentEditing] = useState(null);

  const {
    handleSubmit,
    control,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: { ...siteSLADefault, SLAs: [...SLAs] },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    region: { required: "Please Select Region" },
    serviceType: { required: "Please Select Service Type" },
    activityType: { required: "Please Select Service Type" },
    responseTime: {
      required: "Please Select Service Type",
      validate: (value) => {
        if (!value || value === "0") return "Please Enter Value";
        return true;
      },
    },
    attendedTime: {
      required: "Please Select Service Type",
      validate: (value) => {
        if (!value || value === "0") return "Please Enter Value";
        return true;
      },
    },
    resolutionTime: {
      required: "Please Select Service Type",
      validate: (value) => {
        if (!value || value === "0") return "Please Enter Value";
        return true;
      },
    },
  };
  const { fields: SLAfields, remove: SLARemove } = useFieldArray({
    control: generalFieldProps.control,
    name: "SLAs",
  });
  useEffect(() => {
    if (addData) {
      addData([...SLAfields]);
    }
  }, [SLAfields]);
  const submitInfo = (data) => {
    const _SLAs = [...SLAfields];
    const _SLA = {
      region: data.region,
      serviceType: data.serviceType,
      activityType: data.activityType,
      responseTime: data.responseTime,
      attendedTime: data.attendedTime,
      resolutionTime: data.resolutionTime,
    };
    if (currentEditing !== null) {
      _SLAs[currentEditing] = { ..._SLA };
      setCurrentEditing(null);
    } else {
      _SLAs.push(_SLA);
    }
    reset({
      ...siteSLADefault,
      SLAs: [..._SLAs],
    });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            reset({
              ...getValues(),
              ...dataItem,
              SLAs: [...SLAfields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete"
          cursor="pointer"
          onClick={() => {
            SLARemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const onCancelEditing = () => {
    reset({ ...siteSLADefault, SLAs: [...SLAfields] });
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Site SLA</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            gap="16px"
            onClick={() => {}}
          >
            <Button type="button" onClick={() => onPrevStep(SLAfields)}>
              Back
            </Button>
            <Button type="button" onClick={() => onNextStep(SLAfields)}>
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Service Type"
        name="serviceType"
        id="id"
        text="text"
        data={[
          {
            id: "FLM",
            text: "FLM",
          },
          {
            id: "SLM",
            text: "SLM",
          },
        ]}
        placeholder="Select Service Type"
        rules={formValidationRules.serviceType}
        dropdownProps={{ filterable: true }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Activity Type"
        name="activityType"
        id="id"
        text="text"
        data={[
          {
            id: "FLM",
            text: "FLM",
          },
          {
            id: "SLM",
            text: "SLM",
          },
        ]}
        placeholder="Select Activity Type"
        rules={formValidationRules.activityType}
        dropdownProps={{ filterable: true }}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        name="responseTime"
        label="Response Time(mins)"
        inputProps={{ format: "#", className: "hide-spinners" }}
        rules={formValidationRules.responseTime}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        name="attendedTime"
        label="Attended Time(mins)"
        inputProps={{ format: "#", className: "hide-spinners" }}
        rules={formValidationRules.attendedTime}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        name="resolutionTime"
        label="Resolution Time(mins)"
        inputProps={{ format: "#", className: "hide-spinners" }}
        rules={formValidationRules.resolutionTime}
      />
      <Grid data={SLAfields} style={{ width: "100%" }}>
        <GridColumn title="Service Type" field="serviceType.text" />
        <GridColumn title="Activity Type" field="activityType.text" />
        <GridColumn title="Response Time" field="responseTime" />
        <GridColumn title="Attended Time" field="attendedTime" />
        <GridColumn title="Resolution Time" field="resolutionTime" />
        <GridColumn title="Edit" cell={editCell} width={120} />
        <GridColumn title="Delete" cell={deleteCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button
            onClick={() => {
              onCancelEditing();
            }}
          >
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null ? "Update SLA" : "Add SLA"}
        </Button>
      </div>
    </form>
  );
}
